module.exports = __webpack_public_path__ + "img/yu.1f1c7cf7.png";